const Lead = () => {
    return (
        <div>
            <h1>Лид</h1>
        </div>
    );
};

export default Lead;
